import type { KpiCardSpec } from './card-spec';

/**
 * The Promotions activated scalar, shown on the Acquisition page's Coupons
 * section and the Users page's User actions section. One object in two
 * catalogs, so the two pages cannot report different figures.
 */
export const PROMOTIONS_ACTIVATED_SCALAR_CARD: KpiCardSpec = {
    title: 'Promotions activated',
    source: 'coupon-activation',
    metric: 'claimed',
    form: 'number',
    size: 'sm',
};
